<section class="w-full h-full bg-white md:px-10 md:py-16 px-4 py-8 overflow-x-hidden">
  <div class="container mx-auto h-full w-full">
    <div
      class="flex md:flex-row flex-col justify-between md:gap-14 gap-8 items-center h-full w-full"
    >
      <div class="flex flex-col items-start justify-center max-md:w-full w-1/2">
        <h2
          i18n="lite.tournament|Tournaments Made Easy heading@@lite.tournament.title"
          class="md:text-3xl text-2xl font-bold text-main-blue-light"
        >
          Tournaments Made Easy
        </h2>
        <p
          i18n="
            lite.tournament|Simple to run, fun to join, and ready to share
            heading@@lite.tournament.createInviteJoin"
          class="text-main-black text-sm md:text-base font-medium"
        >
          Simple to run, fun to join, and ready to share
        </p>
        <p
          i18n="
            lite.tournament|Create your brackets in a flash, let players hop right in, and track
            scores effortlessly description@@lite.tournament.description"
          class="text-[#9B9B9B] text-lg md:text-xl mt-6"
        >
          Create your brackets in a flash, let players hop right in, and track scores effortlessly.
        </p>
      </div>
      <div class="max-md:w-full w-1/2 rounded-2xl overflow-hidden h-full">
        <img
          src="lite/tournaments.jpg"
          alt="Tournament Image"
          class="w-full h-full object-contain"
        />
      </div>
    </div>
  </div>
</section>
